import { SupplierCompanyMessage } from '../../../../../types/SupplierCompanyMessage';
import { GeneralInformation } from '../../../GeneralInformation';

interface SupplierDetailsTabProps {
    supplier: SupplierCompanyMessage;
    onEditSubmit: (data: SupplierCompanyMessage) => Promise<void>;
}

export const SupplierDetailsTab = ({ supplier, onEditSubmit }: SupplierDetailsTabProps) => {
    return <GeneralInformation onEditSubmit={onEditSubmit} companyDetails={supplier} />;
};
